.stepper {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  counter-reset: step;
}

.horizontal {
  flex-direction: row;
  gap: var(--space-2);
}

.vertical {
  flex-direction: column;
  gap: var(--space-4);
}

.step {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: var(--space-2-5);
  flex: 1 1 0;
  min-width: 0;
}

.horizontal .step:not(:last-child)::after {
  content: '';
  flex: 1 1 auto;
  align-self: center;
  min-width: var(--space-4);
  height: 2px;
  margin: 0 var(--space-2);
  border-radius: 1px;
  background-color: var(--color-border);
}

.horizontal .complete:not(:last-child)::after {
  background-color: var(--color-primary);
}

.vertical .step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 2rem;
  bottom: calc(-1 * var(--space-4) + var(--space-1));
  left: 0.875rem;
  width: 2px;
  background-color: var(--color-border);
}

.vertical .complete:not(:last-child)::after {
  background-color: var(--color-primary);
}

.marker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  border: 2px solid var(--color-border-strong);
  border-radius: 50%;
  background-color: var(--color-surface);
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  font-variant-numeric: tabular-nums;
}

.complete .marker {
  border-color: var(--color-primary);
  background-color: var(--color-primary);
  color: var(--color-primary-contrast);
}

.current .marker {
  border-color: var(--color-primary);
  color: var(--color-link);
  box-shadow: 0 0 0 3px var(--color-primary-subtle);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-0-5);
  min-width: 0;
  padding-top: 0.2rem;
}

.label {
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current .label,
.complete .label {
  color: var(--color-text);
}

.current .label {
  font-weight: var(--font-weight-semibold);
}

.description {
  color: var(--color-text-subtle);
  font-size: var(--font-size-xs);
}

.vertical .label {
  white-space: normal;
}

@media (max-width: 640px) {
  .horizontal .step:not(.current) .text {
    display: none;
  }
}
